import { useEffect, useState } from "react";

import apiClient from "../../../services/apiClient";
import Modal from "../../../components/Modal";
import CloseButton from "../../../components/CloseButton";

// 수학 풀이 사진 보기 · 정성 매기기(2026-10-06). 서버: api/assignment/math_work_photo.py
// 잘함 · 보통 · 다시. '다시' 면 학생 화면에 다시 올려 달라고 뜬다
// 사진 아래 코멘트는 비워도 된다. 매기는 버튼을 누를 때 같이 저장되고 아이 화면에 보인다
export const WORK_PHOTO_RATING_LIST = [
  { value: "good", label: "잘함", color: "#00A396" },
  { value: "ok", label: "보통", color: "#5B6670" },
  { value: "retry", label: "다시", color: "#D63C5E" },
];

const MathWorkPhotoModal = ({ assignmentId, onClose, onRated }) => {
  const [data, setData] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [comment, setComment] = useState("");

  useEffect(() => {
    apiClient
      .get("/api/v1/assignment/math/work-photo/teacher", { params: { assignment_id: assignmentId }, withAuth: true })
      .then((response) => {
        setData(response.data);
        setComment(response.data.comment || "");
      })
      .catch(() => setData({ error: true }));
  }, [assignmentId]);

  const rate = async (rating) => {
    setIsSaving(true);
    try {
      const response = await apiClient.post(
        "/api/v1/assignment/math/work-photo/teacher",
        { assignment_id: assignmentId, rating, comment },
        { withAuth: true }
      );
      setData(response.data);
      if (onRated) onRated(rating);
    } catch (error) {
      alert(error?.response?.data?.error || "저장하지 못했어요.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal>
      <div
        style={{
          position: "relative",
          width: "min(860px, calc(100vw - 40px))",
          maxHeight: "86vh",
          display: "flex",
          flexDirection: "column",
          background: "#fff",
          borderRadius: "18px",
          overflow: "hidden",
        }}
      >
        <CloseButton onClick={onClose} />
        <div style={{ padding: "22px 22px 10px" }}>
          <div className="ws-modal-title">
            {data?.student_name} 풀이 사진
          </div>
          <p className="ws-modal-sub">{data?.title}</p>
        </div>
        <div style={{ flex: 1, minHeight: 0, overflowY: "auto", padding: "4px 22px 16px" }}>
          {!data && <p className="ws-modal-sub">불러오는 중입니다.</p>}
          {data?.error && <p className="ws-modal-sub">불러오지 못했습니다.</p>}
          {data && !data.error && data.file_list.length === 0 && <p className="ws-modal-sub">아직 올리지 않았어요.</p>}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: "10px" }}>
            {(data?.file_list || []).map((file) => (
              <a key={file.url} href={file.url} target="_blank" rel="noopener noreferrer" title="크게 보기">
                {/\.pdf$/i.test(file.url) ? (
                  <div style={{ padding: "40px 0", textAlign: "center", border: "1px solid #E6EDEC", borderRadius: "12px" }}>PDF 열기</div>
                ) : (
                  <img src={file.url} alt="" style={{ width: "100%", borderRadius: "12px", border: "1px solid #E6EDEC" }} />
                )}
              </a>
            ))}
          </div>
          {data && !data.error && data.file_list.length > 0 && (
            <textarea
              value={comment}
              onChange={(event) => setComment(event.target.value)}
              placeholder="아이에게 한마디 (안 써도 돼요)"
              rows={3}
              maxLength={500}
              style={{
                width: "100%",
                boxSizing: "border-box",
                marginTop: "12px",
                padding: "12px 14px",
                border: "1px solid #E6EDEC",
                borderRadius: "12px",
                fontFamily: "inherit",
                fontSize: "16px",
                resize: "vertical",
              }}
            />
          )}
        </div>
        {data && !data.error && data.file_list.length > 0 && (
          <div className="ws-bottom-bar" style={{ justifyContent: "flex-end", gap: "8px" }}>
            {WORK_PHOTO_RATING_LIST.map((one) => (
              <button
                key={one.value}
                type="button"
                disabled={isSaving}
                onClick={() => rate(one.value)}
                style={{
                  padding: "10px 22px",
                  borderRadius: "999px",
                  border: `1.5px solid ${one.color}`,
                  background: data.rating === one.value ? one.color : "#fff",
                  color: data.rating === one.value ? "#fff" : one.color,
                  fontWeight: 800,
                  fontFamily: "inherit",
                  cursor: "pointer",
                }}
              >
                {one.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default MathWorkPhotoModal;
